import { Navigate } from 'react-router'

import { useActivationContext } from '../../providers/activation-provider'

import PlacementSuggestionsLeakFreeze from './device-types/leak-freeze'
import PlacementSuggestionsSlim from './device-types/slim'

const PlacementSuggestions = () => {
  const {
    activationLocationState: { nodeTypeName },
  } = useActivationContext()

  if (nodeTypeName === 'leak5s') return <PlacementSuggestionsSlim />
  if (nodeTypeName === 'nbiot_leak') return <PlacementSuggestionsLeakFreeze />
  return <Navigate to="-1" />
}

export default PlacementSuggestions
